<template>
    <TopNav/>
    <div class="container">
         <LeftNav />
         <div class="d-flex flex-direction-column info-middle">
            <div class="d-flex align-items-center justify-content-between info-top-actions">
                <span class="top-label">Info</span>
                <button @click="openFilePicker" class="primary d-flex gap-5"><UploadIcon/> Upload File</button>
                <UploadFileModal v-if="showFileUploadModal"/>
                <input type="file" ref="fileInput" accept=".pdf, .doc, .docx, .txt" @change="onFileChange" style="display:none" multiple/>

            </div>
            <div class="d-flex align-items-center justify-content-between filters-div">
                <div class="d-flex">
                    <button @click.prevent="fileFilter.type = ''"   :class="{'secondary': true,'d-flex': true,'selected': !fileFilter.type }" @click="toggleSelected" >View All</button>
                    <button @click.prevent="fileFilter.type = 'document'" :class="{'secondary': true,'d-flex': true,'selected': fileFilter.type == 'document' }">Documents</button>
                    <button @click.prevent="fileFilter.type = 'pdf'" :class="{'secondary': true,'d-flex': true,'selected': fileFilter.type == 'pdf' }">PDFs</button>
                </div>
                <div class="d-flex">
                    <input v-model="fileFilter.name" type="text" placeholder="Search Files">
                </div>
            </div>   
            <div class="table-container">
                <table class="files-table">
                    <thead class="table-head">
                        <tr>
                            <th class="d-flex align-items-center gap-1-rem" style="text-align: left">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span></span>
                                </label>
                                File name
                            </th>
                            <th>Label</th>
                            <th >Date uploaded</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="table-body">
                        <tr v-for="file,index in filteredUserFiles" :key="index">
                            <td class="d-flex gap-1-rem">
                                <label class="custom-checkbox">
                                    <input type="checkbox">
                                    <span></span>
                                </label>
                                <div class="d-flex flex-direction-column">
                                    {{file.name}}<br />
                                    <small>{{formatFileSize(file.size)}}</small>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex gap-5 add-task-div color-primary cursor-pointer justify-content-center">
                                    <PlusCircleIcon/> <span>Add Task</span>
                                </div>  
                                <div class="label-dropdown">
                                    <ul class="dropdown-menu">
                                    <li><span class="label-color yellow"></span> Visual Design</li>
                                    <li><span class="label-color blue"></span> UX / UI</li>
                                    <li><span class="label-color pink"></span> UX / CX</li>
                                    <li><span class="label-color gray"></span> Create new label</li>
                                    </ul>
                                </div>
                            </td>
                            <td class="d-flex justify-content-between" >
                                <span>{{formatDate(file.updated)}}</span>
                                <MenuIcon class="menu-icon"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
   
        </div>



         <div class="d-flex flex-direction-column info-middle" style="display: none;">
            <div class="file-upload">
                <h2>Upload a File</h2>
                <input type="file" @change="onFileChange" />
                <button @click="uploadFile" :disabled="!selectedFile">Upload</button>
                uploadStatus            </div>
            <form  v-if="questions" @submit.prevent="handleSubmit" class="d-flex flex-direction-column gap-5 w-100 questions-form" >
                <div v-for="(field, index) in questions" :key="index" class="d-flex flex-direction-column gap-5">
                    <label :for="field.name" >{{ field.question }}</label>
                    <div v-if="field.type == 'textarea'" class="textarea-background" style="margin-top: 10px">
                        <textarea
                        :id="field.name"
                        rows="3"
                        :name="field.name"
                        ></textarea>
                    </div>
                    <input
                        v-if="field.type == 'input'"
                        :id="field.name"
                        type="text"
                        v-model="field.answer"
                        class="form-input"
                        name="field.name"
                    />
                </div>
                <button type="submit" data-text="Save" class="primary email-button">Save</button>
            </form>
         </div>
   
    </div>
  </template>
  
  <script>
    import LeftNav from '@/components/LeftNav.vue';
    import TopNav from '@/components/TopNav.vue';
    import dataService from '@/services/dataService';
    import UploadIcon from '@/components/icons/UploadIcon.vue';
    import PlusCircleIcon from '@/components/icons/PlusCircleIcon.vue';
    import MenuIcon from '@/components/icons/MenuIcon.vue';
    import UploadFileModal from '@/components/UploadFileModal.vue';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            LeftNav,
            TopNav,
            UploadIcon,
            MenuIcon,
            PlusCircleIcon,
            UploadFileModal
        },
        computed: {
            ...mapGetters(['showFileUploadModal','userFiles']),
            filteredUserFiles() {
                // If no filters are applied, return all files
                if (!this.fileFilter.type && !this.fileFilter.name) {
                return this.userFiles;
                }

                const mimeTypeMap = {
                document: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
                pdf: ['application/pdf'], // Matches contentType for PDFs
                image: ['image/jpeg', 'image/png', 'image/gif'],
                };

                return this.userFiles.filter(file => {
                // Check for MIME type filter
                const matchesType = this.fileFilter.type
                    ? (mimeTypeMap[this.fileFilter.type] || []).includes(file.contentType)
                    : true;

                // Check for file name filter (case-insensitive)
                const matchesName = this.fileFilter.name
                    ? file.name.toLowerCase().includes(this.fileFilter.name.toLowerCase())
                    : true;

                // Return files that match both conditions
                return matchesType && matchesName;
                });
            },
        },
      data() {
            return {
                questions: [
            {
                "name": "full_name",
                "question": "Full Name",
                "answer": "",
                "type": "input",
                "required": 1
            },
            {
                "name": "email_address",
                "question": "Email Address",
                "answer": "",
                "type": "input",
                "required": 1
            },
            {
                "name": "company_name",
                "question": "Company Name",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "phone_number",
                "question": "Phone Number",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "cell_number",
                "question": "Cell Number",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "job_title",
                "question": "Job Title/Position",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "department",
                "question": "Department",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "office_address",
                "question": "Office Address",
                "answer": "",
                "type": "textarea",
                "required": 0
            },
            {
                "name": "preferred_contact_method",
                "question": "Preferred Contact Method",
                "answer": "",
                "type": "select",
                "options": ["Email", "Phone", "Cell", "SMS", "Other"],
                "required": 0
            },
            {
                "name": "linkedin_profile_url",
                "question": "LinkedIn Profile URL",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "website_portfolio_url",
                "question": "Website or Portfolio URL",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "skype_id",
                "question": "Skype ID",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "twitter_handle",
                "question": "Twitter Handle",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "facebook_profile_url",
                "question": "Facebook Profile URL",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "instagram_handle",
                "question": "Instagram Handle",
                "answer": "",
                "type": "input",
                "required": 0
            },
            {
                "name": "additional_contact_information",
                "question": "Additional Contact Information",
                "answer": "",
                "type": "textarea",
                "required": 0
            }
        ],
        selectedFiles: null, 
        fileFilter: {type: '', name: ''},
        }; 
      }, 
      mounted() {
        this.getUserData();
        this.getUserFiles();
      },
      methods: {
        openFilePicker(){
            this.$refs.fileInput.click();
        },
        async getUserFiles(){
            await this.$store.dispatch('fetchUserFiles');
        },
        async onFileChange(event) {
            console.log('wagwan');
            this.$store.dispatch('setShowFileUploadModal', true);
            const files = event.target.files;
            if (files) {
                this.selectedFiles = files;
            }
            try {
                 await this.$store.dispatch('uploadFileToGCP', this.selectedFiles);
            } catch (error) {
                console.error(error);
                this.uploadStatus = 'Upload failed.';
            }
        },
        async handleSubmit(){
            const simplifiedData = this.questions.reduce((acc, { name, answer }) => {
                acc[name] = answer;
                return acc;
            }, {});
            await dataService.editData(simplifiedData);

        },
        async getUserData() {
            try {
                const userData = await dataService.getData(); // Fetch user data
                if (userData) {
                    this.questions.forEach(question => {
                        if (Object.prototype.hasOwnProperty.call(userData, question.name)) {
                            question.answer = userData[question.name] || ''; // Update answer
                        }
                    });
                } else {
                    console.warn('No user data found in the response.');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                // Handle the error as needed
            }
        },
        formatFileSize(sizeInBytes) {
            if (sizeInBytes === 0) return '0 Bytes';
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
            const formattedSize = (sizeInBytes / Math.pow(1024, i)).toFixed(2);
            return `${formattedSize} ${sizes[i]}`;
        },
        formatDate(isoString) {
            const date = new Date(isoString);

            // Get day, month, and year
            const day = date.getDate();
            const year = date.getFullYear();
            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
            const month = months[date.getMonth()];

            // Determine the ordinal suffix
            const suffix = (day % 10 === 1 && day !== 11) ? 'st' :
                            (day % 10 === 2 && day !== 12) ? 'nd' :
                            (day % 10 === 3 && day !== 13) ? 'rd' : 'th';

            // Return formatted date
            return `${month} ${day}${suffix}, ${year}`;
        },
       
      },
    };
  </script>
  
<style scoped>
.menu-icon {
  transform: rotate(90deg);
  transform-origin: center;
  fill: var(--dark-color-6b);
  stroke: var(--dark-color-6b);
}

/* Table Spacing */
.table-body td {
  padding: 10px 5px !important;
}
.table-head th {
  padding: 10px 5px !important;
}

/* Remove borders & spacing */
table, th, td {
  border: none;
  border-spacing: 0;
}

/* Table Head */
.table-head {
  background-color: var(--Theme-Color-Secondary-Black); /* #1A1A1A */
  padding: 1rem;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: var(--dark-colo-a0); /* #A0A0A0 */
}
.table-head th:first-child {
  border-radius: 5px 0 0 0px !important;
}
.table-head th:last-child {
  border-radius: 0 5px 0 0 !important;
}

/* Files Table */
.files-table {
  width: 100%;
}
.table-container {
  width: 60rem;
}

/* Filters Buttons */
.filters-div {
  width: 60rem;
  margin-bottom: 1rem;
}
.filters-div button {
  border-radius: 0px !important;
}
.filters-div button:first-child {
  padding: 10px !important;
  border-radius: 5px 0 0 5px !important;
}
.filters-div button:last-child {
  padding: 10px !important;
  border-radius: 0 5px 5px 0 !important;
}

/* Highlighted State */
.selected {
  background-color: var(--black-colo-08); /* or keep #434343 if you prefer */
}

/* Top Label */
.top-label {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: var(--dark-colo-a0); /* Kept as-is, or define a new variable if you like */
}

/* Middle & Top Actions */
.info-middle {
  flex-grow: 1;
  align-items: center;
  margin-top: 80px;
}
.info-top-actions {
  width: 60rem;
  border-bottom: 1px solid var(--gray-color-2c); /* #2C2C2C */
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

/* Labels */
label {
  color: rgb(205, 205, 205); /* Could map to #E0E0E0 or var(--dark-colo-a0) if you prefer */
}

/* Textarea Background */
.textarea-background {
  background-color: #383838; /* Or var(--Theme-Color-Secondary-Black), etc. */
  border-radius: 15px;
  display: flex;
  padding: 15px;
}

/* Questions Form */
.questions-form {
  width: 30rem;
}

</style>